import "./SewageCleanup.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Overview from "./sections/Overview";
import WhyChooseTriserveRelatedServices from "./sections/WhyChooseTriserveRelatedServices";
import Request from "./sections/Request";
import Footer from "@/reusable_sections/Footer";
export default function SewageCleanupPage() {
  return <div>
      <Header />
      <Hero />
      <Overview />
      <WhyChooseTriserveRelatedServices />
      <Request />
      <Footer />
    </div>;
}